import {
  BaseApiService,
  type JsonApiResource,
  type JsonApiResponse,
} from './base.service';
import type { TbankCheckoutSessionAttributes } from '@/types/checkout';

/**
 * T-Bank (RU web rail) checkout sessions. Unlike Paddle there is no client SDK:
 * the server mints the purchase intent itself, calls Init, and returns the
 * bank-hosted `payment_url` for a full-page redirect. The notification webhook
 * owns the grant; `getSession` is only the return-page status poll.
 */
class TbankService extends BaseApiService {
  async createSession(
    slug: string,
    projectId?: string,
    receiptEmail?: string
  ): Promise<JsonApiResource<TbankCheckoutSessionAttributes>> {
    const body = this.formatJsonApiData('tbank-checkout-session', {
      slug,
      ...(projectId ? { project_id: projectId } : {}),
      // Accounts without an e-mail (ADR-001) give the fiscal receipt address here.
      ...(receiptEmail ? { receipt_email: receiptEmail } : {}),
    });

    const response = await this.post<
      JsonApiResponse<JsonApiResource<TbankCheckoutSessionAttributes>>
    >('/v1/tbank/checkout-sessions', body);

    return response.data;
  }

  async getSession(
    id: string
  ): Promise<JsonApiResource<TbankCheckoutSessionAttributes>> {
    const response = await this.httpGet<
      JsonApiResponse<JsonApiResource<TbankCheckoutSessionAttributes>>
    >(`/v1/tbank/checkout-sessions/${id}`);

    return response.data;
  }
}

export const tbankService = new TbankService();
